import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ViewMode, Message, dispatchCtx, documentsCtx } from "../Documents/DocumentContext.js";
import { API_Document_Download, generateQueryString, API_Document_CustomerDocuments } from "../Shared/Urls.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Document$, Machine_$reflection, DocumentCategory_$reflection, Document$_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { value as value_95, some, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString as toString_1 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { stringHash, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { toArray, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableBody, Link, IconButton, TableHead, TableRow, Checkbox, TableCell, Table, TableContainer, Collapse, Icon } from "@mui/material";
import { SnackError, loadingIndicatorSmall } from "../ViewHelpers.js";
import FolderOpen from "@mui/icons-material/FolderOpen";
import Folder from "@mui/icons-material/Folder";
import { singleton as singleton_2, append as append_1, contains, map as map_1, choose, partition } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Tree$2_$reflection, Tree_tryLeaf, Tree_tryNode, Tree_isNode } from "../Shared/Tree.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { actionColumn, hiddenColumn, syncColumn, sourceColumn, dateColumn, Table_FilenameCell_Z6EA07FE8, docTableIconHeader, docTableTextHeader, docsLoadingIndicators, MachineCategory, filterDocs, emptyCategory } from "../Documents/DocumentHelpers.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { DrawTree } from "../Machine/MachineDocumentTree.js";
import { TreeNode } from "../Components/Documents/CustomerAttachments.js";
import { ctx as ctx_1 } from "../Context.js";
import { getDocumentsForCategory } from "../Documents/Trees.js";
import { Documents_VisibilityPopup_Z6D335E41 } from "../Components/Documents/VisibilityPopup.js";
import { Documents_GridItem_Z6D87F33A, Documents_Container_Z39E676A4, Documents_ContainerWithFilter_Z2776732D } from "../Components/Documents/DocumentViewer.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Documents_DocumentSource_FromId_Z524259A4 } from "../Shared/Shared.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import Clear from "@mui/icons-material/Clear";
import { toDateStr } from "../Locale.js";
import { parse as parse_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import Download from "@mui/icons-material/Download";
import { Upload_EditButton_13687765 } from "../Components/Documents/Upload.js";
import { Button } from "../Components/Documents/Delete.js";
import { TopLevel_Table_763CA090 } from "../Components/Documents/TopLevel.js";

function EvaticDocuments(evaticDocumentsInputProps) {
    let elems_2, elems_1, elems, props_1, props_3;
    const customerId = evaticDocumentsInputProps.customerId;
    const groupId = evaticDocumentsInputProps.groupId;
    const key = evaticDocumentsInputProps.$key;
    const model = reactApi.useContext(documentsCtx);
    const showDeleted = model.Filter.ShowDeleted;
    const dispatch = reactApi.useContext(dispatchCtx);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const isOpen = patternInput_1[0];
    const dependencies = [isOpen, showDeleted];
    reactApi.useEffect(() => {
        let properties_2;
        const url = API_Document_CustomerDocuments(customerId) + generateQueryString([["evatic", toString(true)], ["deleted", toString(showDeleted)]]);
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Document$_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Document$_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                dispatch(new Message(20, [res.fields[0]]));
            }
            else {
                console.error(some("Could not load evatic documents"), res.fields[0]);
            }
            setLoading(false);
        });
    }, dependencies);
    const xs_4 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append((model.EvaticDocuments.length === 0) ? singleton(["display", "none"]) : empty_1(), delay(() => singleton(["width", 100 + "%"]))))))], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontSize: 0.8 + "rem",
    }], ["onClick", (_arg_2) => {
        patternInput_1[1](!isOpen);
        dispatch(new Message(9, [new ViewMode(1, [])]));
    }], (elems = [MuiHelpers_createElement(Icon, [["style", {
        color: "#dec66f",
        marginRight: 5,
    }], ["children", patternInput[0] ? loadingIndicatorSmall() : (isOpen ? ((props_1 = {}, react.createElement(FolderOpen, props_1))) : ((props_3 = {}, react.createElement(Folder, props_3))))]]), createElement("span", {
        style: {
            textDecorationLine: "underline",
        },
        children: "Evatic",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

function MachineFolders(machineFoldersInputProps) {
    let elems_3, elems, props_1, elements, elems_1;
    const machineDocument = machineFoldersInputProps.machineDocument;
    const customerId = machineFoldersInputProps.customerId;
    const key = machineFoldersInputProps.$key;
    const model = reactApi.useContext(documentsCtx);
    const dispatch = reactApi.useContext(dispatchCtx);
    const patternInput = reactApi.useState(false);
    const isOpen = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setLoading = patternInput_1[1];
    const loading = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    let selected;
    const matchValue = model.ViewMode;
    selected = ((matchValue.tag === 0) && (matchValue.fields[0] === machineDocument.Machine.Id));
    let patternInput_4;
    const patternInput_3 = partition(Tree_isNode, machineDocument.Trees);
    patternInput_4 = [choose(Tree_tryNode, patternInput_3[0]), choose(Tree_tryLeaf, patternInput_3[1])];
    useEffectWithDeps(() => {
        let properties_2;
        if (isOpen) {
            setLoading(true);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`/api/machine-document-tree/build/${machineDocument.Machine.Id}`, properties_3).then((_arg_1) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                        let matchValue_1;
                        return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                setLoading(false);
                if (res.tag === 0) {
                    dispatch(new Message(14, [machineDocument.Machine.Id, res.fields[0]]));
                    dispatch(new Message(9, [new ViewMode(0, [machineDocument.Machine.Id, emptyCategory(undefined, undefined).Id])]));
                }
                else {
                    setErrMsg("Kunne ikke laste dokumenter");
                }
            });
        }
        return createDisposable(() => {
            console.debug("Disposing Tree");
        });
    }, [isOpen]);
    const xs_4 = [createElement(SnackError, {
        errMsg: unwrap(patternInput_2[0]),
        dismiss: () => {
            setErrMsg(undefined);
        },
    }), createElement("div", createObj(ofArray([["style", {}], (elems_3 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["padding", 5 + "px"]), delay(() => append(singleton(["borderRadius", 5 + "px"]), delay(() => append(singleton(["cursor", "pointer"]), delay(() => append(singleton(["fontSize", 0.8 + "rem"]), delay(() => (selected ? singleton(["backgroundColor", "rgba(98, 181, 229, 0.2)"]) : empty_1()))))))))))))))))], ["onClick", (_arg_4) => {
        console.debug("[CustomerDocuments] Clicked thingy", machineDocument);
        patternInput[1](!isOpen);
    }], ["onDragOver", (_arg_5) => {
        console.debug("Being dragged over!");
    }], (elems = [MuiHelpers_createElement(Icon, [["style", {
        color: "var(--navy)",
        marginRight: 5,
    }], ["children", loading ? loadingIndicatorSmall() : ((props_1 = {}, react.createElement(Folder, props_1)))]]), createElement("span", {
        children: machineDocument.Machine.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Collapse, [["style", {
        paddingLeft: 20,
    }], ["mountOnEnter", true], ["in", !loading && isOpen], (elements = [map_1((tupledArg_1) => {
        const folder = tupledArg_1[0];
        const machineId_1 = machineDocument.Machine.Id | 0;
        const $key157DF583 = `tree-${machineId_1}-${folder.Id}`;
        return createElement(DrawTree, {
            key: $key157DF583,
            $key: $key157DF583,
            layer: 0,
            customerId: customerId,
            machineId: machineId_1,
            children: tupledArg_1[1],
            category: folder,
        });
    }, patternInput_4[0].filter((tupledArg) => !(tupledArg[1].length === 0))), createElement("div", createObj(singleton_1((elems_1 = [createElement(TreeNode, {
        key: "tree-customer-documents",
        $key: "tree-customer-documents",
        customerId: customerId,
        machineId: machineDocument.Machine.Id,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

/**
 * Wrapper component to seperate the machines ReactComponents and the CustomerDocuments component,
 * avoiding full refetch of all machine components on state updates done on the CustomerDocuments
 * component. E.g. toggling the HideForm will re-render all machine components.
 */
export function View(viewInputProps) {
    let matchValue, s, matchValue_1, elems_13, elems_2, elems_1, elements_9, elements_8, children_1, children, children_6;
    const customerId = viewInputProps.customerId;
    const groupId = viewInputProps.groupId;
    const key = viewInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const model = reactApi.useContext(documentsCtx);
    const dispatch = reactApi.useContext(dispatchCtx);
    const patternInput = reactApi.useState(true);
    const patternInput_1 = reactApi.useState([]);
    const setSelectedDocs = patternInput_1[1];
    const selectedDocs = patternInput_1[0];
    const isAdmin = ((matchValue = ctx.Session, (matchValue != null) ? ((s = matchValue, [s.IsPtg, s.IsAdmin ? true : s.IsSuperAdmin])) : [false, false]))[1];
    const filteredDocs = filterDocs(ctx.DateFnsLocale, undefined, model.Filter, (matchValue_1 = model.ViewMode, (matchValue_1.tag === 2) ? model.CustomerDocs : ((matchValue_1.tag === 1) ? model.EvaticDocuments : ((matchValue_1.tag === 3) ? [] : getDocumentsForCategory(model.MachineCategories, matchValue_1.fields[0], matchValue_1.fields[1])))));
    const dependencies = [customerId];
    reactApi.useEffect(() => {
        let properties_2;
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Machine_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`/api/customer/${customerId}/machines`, properties_3).then((_arg_1) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Machine_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                    let matchValue_3;
                    return Promise.resolve((matchValue_3 = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue_3.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_3.fields[0]])])) : (new FSharpResult$2(0, [matchValue_3.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            patternInput[1](false);
            if (res.tag === 0) {
                dispatch(new Message(15, [map_1((machine) => (new MachineCategory(machine, [])), res.fields[0])]));
            }
            else {
                console.error(some("Failed fetching machines:"), res.fields[0]);
            }
        });
    }, dependencies);
    const xs_4 = [createElement(Documents_VisibilityPopup_Z6D335E41, {
        onUpdate: (doc_1) => {
            const updated = new Document$(doc_1.Guid, doc_1.Number, doc_1.CustomerId, doc_1.Title, doc_1.CategoryTreeId, doc_1.TypeId, doc_1.Machine, doc_1.SourceId, doc_1.Date, doc_1.Uploader, !doc_1.IsHidden, doc_1.IsDeleted, doc_1.Version, doc_1.Uploaded, doc_1.ManuallyMoved, doc_1.ContentId, doc_1.Filename, doc_1.ContentSizeBytes, doc_1.Versions);
            const matchValue_4 = updated.Machine;
            if (matchValue_4 != null) {
                dispatch(new Message(17, [matchValue_4.Id, updated.CategoryTreeId, updated]));
            }
            else {
                dispatch(new Message(19, [updated]));
            }
        },
        onClose: () => {
            dispatch(new Message(3, [undefined]));
        },
        document: unwrap(model.HiddenDoc),
    }), createElement(Documents_ContainerWithFilter_Z2776732D, {
        selectedDocs: selectedDocs,
        children: [createElement(Documents_Container_Z39E676A4, {
            children: [createElement("div", createObj(ofArray([["className", join(" ", ["documents-container-item"])], ["style", {
                display: "flex",
                backgroundColor: "var(--medium-grey)",
                borderRadius: 15 + "px",
            }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
                flexBasis: 40 + "ch",
                maxWidth: 60 + "ch",
                padding: ((((((30 + "px") + " ") + (20 + "px")) + " ") + (30 + "px")) + " ") + (20 + "px"),
            }], (elems_2 = [createElement("div", createObj(ofArray([["style", {}], (elems_1 = toList(delay(() => (patternInput[0] ? singleton(docsLoadingIndicators()) : append(singleton(map_1((category) => {
                const $keyZ7BB2788 = `machine-folder-${category.Machine.Id}`;
                return createElement(MachineFolders, {
                    key: $keyZ7BB2788,
                    $key: $keyZ7BB2788,
                    customerId: customerId,
                    machineDocument: category,
                });
            }, model.MachineCategories)), delay(() => append(singleton(createElement(EvaticDocuments, {
                key: "evatic-documents",
                $key: "evatic-documents",
                groupId: groupId,
                customerId: customerId,
            })), delay(() => {
                let elems;
                return singleton(createElement("div", createObj(ofArray([["key", "customer-attachments"], (elems = [createElement(TreeNode, {
                    key: "customer-uploaded-document-node",
                    $key: "customer-uploaded-document-node",
                    customerId: customerId,
                })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            }))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), MuiHelpers_createElement(TableContainer, [["className", join(" ", ["large-max-width"])], ["sx", {
                padding: 30 + "px",
                backgroundColor: "var(--light-grey)",
            }], (elements_9 = [MuiHelpers_createElement(Table, [["size", "small"], (elements_8 = [(children_1 = singleton_1((children = toList(delay(() => {
                let elements;
                return append(singleton(MuiHelpers_createElement(TableCell, [["padding", "checkbox"], (elements = [MuiHelpers_createElement(Checkbox, [["disabled", filteredDocs.length === 0], ["onChange", (_arg_3) => {
                    if (!(filteredDocs.length === 0) && (selectedDocs.length === filteredDocs.length)) {
                        setSelectedDocs([]);
                    }
                    else {
                        setSelectedDocs(map_1((_arg_4) => _arg_4.Guid, filteredDocs));
                    }
                }], ["checked", !(filteredDocs.length === 0) && (selectedDocs.length === filteredDocs.length)]])], ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Document"))), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["style", {
                    fontSize: 0.8 + "rem",
                    minWidth: 10 + "ch",
                }], ["variant", "head"], ["children", ctx.Locale.t("History.Date")]])), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Source"))), delay(() => append(singleton(docTableIconHeader(ctx.Locale.t("Document.Sync"))), delay(() => append(isAdmin ? singleton(docTableIconHeader(ctx.Locale.t("Visibility"))) : empty_1(), delay(() => append(singleton(docTableIconHeader(ctx.Locale.t("Document.Download"))), delay(() => (isAdmin ? append(singleton(docTableIconHeader(ctx.Locale.t("Edit"))), delay(() => singleton(docTableIconHeader(ctx.Locale.t("Delete"))))) : empty_1())))))))))))))));
            })), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_6 = singleton_1(map_1((document$) => {
                const source = Documents_DocumentSource_FromId_Z524259A4(document$.SourceId);
                const downloadUrl = API_Document_Download(parse(document$.Guid));
                const isSelected = contains(document$.Guid, selectedDocs, {
                    Equals: (x_1, y) => (x_1 === y),
                    GetHashCode: stringHash,
                });
                return MuiHelpers_createElement(TableRow, toList(delay(() => append(singleton(["key", document$.Guid]), delay(() => append(model.Editing ? append(singleton(["draggable", true]), delay(() => append(singleton(["onDragStart", (e) => {
                    console.debug("On drag start", e);
                }]), delay(() => singleton(["onDragEnd", (e_1) => {
                    console.debug("On drag end", e_1);
                }]))))) : empty_1(), delay(() => append(singleton(["style", createObj(toList(delay(() => (document$.IsDeleted ? singleton(["backgroundColor", "#c1c1c1"]) : empty_1()))))]), delay(() => append(singleton(["hover", true]), delay(() => {
                    let elements_6;
                    return singleton((elements_6 = toList(delay(() => {
                        let elements_3;
                        return append(singleton(MuiHelpers_createElement(TableCell, [["padding", "checkbox"], (elements_3 = [MuiHelpers_createElement(Checkbox, [["onChange", (_arg_5) => {
                            setSelectedDocs(isSelected ? selectedDocs.filter((id) => (id !== document$.Guid)) : append_1(selectedDocs, singleton_2(document$.Guid)));
                        }], ["checked", isSelected]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => append(singleton(createElement(Table_FilenameCell_Z6EA07FE8, {
                            groupId: groupId,
                            customerId: customerId,
                            document: document$,
                            startAdornments: toArray(delay(() => {
                                let props_9;
                                return document$.IsDeleted ? singleton((props_9 = {
                                    style: {
                                        fontSize: 1.2 + "em",
                                    },
                                    color: "error",
                                }, react.createElement(Clear, props_9))) : empty_1();
                            })),
                        })), delay(() => append(singleton(dateColumn(toList(delay(() => ((document$.Date != null) ? singleton(createElement("span", {
                            children: [toDateStr(ctx.DateFnsLocale, parse_1(value_95(document$.Date)))],
                        })) : empty_1()))))), delay(() => append(singleton(sourceColumn([createElement("span", {
                            children: [toString(source)],
                        })])), delay(() => append(singleton(syncColumn(ctx.Locale, document$)), delay(() => append(isAdmin ? singleton(hiddenColumn(toList(delay(() => {
                            let props_13, props_15;
                            return document$.IsHidden ? singleton((props_13 = {
                                style: {
                                    color: "#FF8C00",
                                },
                            }, react.createElement(VisibilityOff, props_13))) : singleton((props_15 = {}, react.createElement(Visibility, props_15)));
                        })))) : empty_1(), delay(() => {
                            let elements_5, elements_4, props_17;
                            return append(singleton(actionColumn([MuiHelpers_createElement(IconButton, [["color", "primary"], ["disabled", document$.ContentId == null], (elements_5 = [MuiHelpers_createElement(Link, [["href", downloadUrl], (elements_4 = [(props_17 = {}, react.createElement(Download, props_17))], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])])])), delay(() => {
                                let $keyZ342E4AA6;
                                return isAdmin ? append(singleton(actionColumn([($keyZ342E4AA6 = document$.Guid, createElement(Upload_EditButton_13687765, {
                                    key: $keyZ342E4AA6,
                                    $key: $keyZ342E4AA6,
                                    customerId: document$.CustomerId,
                                    onClose: (doc) => {
                                        const matchValue_2 = model.ViewMode;
                                        switch (matchValue_2.tag) {
                                            case 2: {
                                                dispatch(new Message(19, [doc]));
                                                break;
                                            }
                                            case 0: {
                                                dispatch(new Message(17, [matchValue_2.fields[0], matchValue_2.fields[1], doc]));
                                                break;
                                            }
                                            case 3: {
                                                break;
                                            }
                                            default:
                                                dispatch(new Message(18, [doc]));
                                        }
                                    },
                                    document: document$,
                                }))])), delay(() => {
                                    let $keyZ4BF1913B;
                                    return singleton(actionColumn([($keyZ4BF1913B = (`document-${document$.Guid}-delete-button`), createElement(Button, {
                                        key: $keyZ4BF1913B,
                                        $key: $keyZ4BF1913B,
                                        document: document$,
                                    }))]));
                                })) : empty_1();
                            }));
                        }))))))))))));
                    })), ["children", reactApi.Children.toArray(Array.from(elements_6))]));
                })))))))))));
            }, filteredDocs)), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_6))]]))], ["children", reactApi.Children.toArray(Array.from(elements_8))])])], ["children", reactApi.Children.toArray(Array.from(elements_9))])])], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))), createElement(Documents_GridItem_Z6D87F33A, {
                children: [createElement(TopLevel_Table_763CA090, {
                    groupId: groupId,
                    customerId: customerId,
                })],
                classes: singleton_1("documents-container-item"),
            })],
        })],
    })];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

